import { MockRecipe, Recipe } from '@domains/recipes';
import { Seo } from '@domains/seo';

import { CategoryPreviewResponse } from './categories';

export type MockProduct = {
    id: number;
    isFavorite: boolean;
    name: string;
    slug: string;
    image: Global.ImageSet;
    pricePerUnit: FeipApi.Kopecks;
    unit: string;
    price: FeipApi.Kopecks;
    promotionPrice?: FeipApi.Kopecks;
    isHorizontal?: boolean;
    isNew?: boolean;
    isPromo?: boolean;
    className?: string;
};

export type MockCharacteristic = {
    label: string;
    value: string;
};

export type MockProductDetails = MockProduct & {
    barcode: string;
    gallery: Global.ImageSet[];
    proteins: number;
    fats: number;
    carbohydrates: number;
    kcal: number;
    description: string;
    characteristics: MockCharacteristic[];
    recipes: MockRecipe[];
    similar_products: MockProduct[];
    buy_with_this_product: MockProduct[];
};

export type MockProducts = MockProduct[];

type MeasureUnitType = {
    id: 'item' | 'kilogram';
    name: string;
};

export type Prices = {
    old: FeipApi.Kopecks | null;
    new: FeipApi.Kopecks;
};

export type MeasureUnit = {
    type: MeasureUnitType;
    price_in_kopecks: Prices;
};

export type PurchaseUnit = {
    measure_units: number;
    price_in_kopecks: Prices;
};

export type NutritionFacts = {
    protein: number;
    fat: number;
    carbohydrate: number;
    calories: number;
};

// NOTE: Add ru translation in utils/product/attributes.ts
export type AttributeName = 'country' | 'manufacturer';
export type Attributes = Record<AttributeName, string | null>;
export type FilteredAttributes = Record<AttributeName, string>;

export enum AvailabilityId {
    InStock = 'in_stock',
    onTheWay = 'on_the_way',
    outOfStock = 'out_of_stock',
}

export type Availability = {
    id: AvailabilityId;
    name: string;
};

export type ProductCategories = FeipApi.Slug[];

export type Product = {
    id: number;
    slug: string;
    name: string;
    is_promo: boolean;
    is_novelty: boolean;
    is_ready_to_eat: boolean;
    is_favorite: boolean;
    availability: Availability;
    measure_unit: MeasureUnit;
    purchase_unit: PurchaseUnit;
    is_available: boolean;
    is_possible_to_order: boolean;
    categories: ProductCategories;
    primary_image: Global.ImageSet;
};

export type ProductDetails = Product & {
    vendor_code: string | null;
    description: string | null;
    has_images: boolean;
    gallery: Global.ImageSet[];
    nutrition_facts_per_100g: NutritionFacts;
    attributes: Attributes;
    seo: Seo;
};

export type ProductsDetailsResponse = {
    recipes: Recipe[];
    product: ProductDetails;
    parent_category: CategoryPreviewResponse | null;
};

export type ProductToggleFavoriteData = { product_id: number };

export type ProductListRequest = {
    page: number;
    page_size: number;
};
